import { SelectOption } from 'components/Select'
import { GroupBase, OptionsOrGroups } from 'react-select'

export const procurementOptions: OptionsOrGroups<
  SelectOption<string>,
  GroupBase<SelectOption<string>>
> = [
  {
    label: 'Disease Parameters',
    options: [
      {
        label: 'Infectious disease',
        value: 'diseaseName',
      },
    ],
  },
  {
    label: 'Country Parameters',
    options: [
      {
        label: 'Recipient',
        value: 'recipients',
      },
      {
        label: 'Income band',
        value: 'recipientIncomeBand',
      },
      {
        label: 'Region',
        value: 'recipientRegion',
      },
      {
        label: 'Donor Country',
        value: 'donorAreas',
      },
    ],
  },
  {
    label: 'Countermeasure Parameters',
    options: [
      {
        label: 'Candidate',
        value: 'candidates',
      },
      {
        label: 'Suppliers',
        value: 'suppliers',
      },
      {
        label: 'Donor Suppliers',
        value: 'donors',
      },
    ],
  },
  {
    label: 'Purchasing Parameters',
    options: [
      {
        label: 'Purchase Category',
        value: 'categoryDetails',
      },
      {
        label: 'Procurement Mechanism',
        value: 'procurementMechanism',
      },
    ],
  },
]

export const xAxisOptions: OptionsOrGroups<
  SelectOption<string>,
  GroupBase<SelectOption<string>>
> = [
  {
    label: 'Candidate',
    value: 'candidates',
  },
  {
    label: 'Year',
    value: 'yearDelivered',
  },
  {
    label: 'Disease',
    value: 'diseaseName',
  },
  {
    label: 'Income Band',
    value: 'recipientIncomeBand',
  },
]
